import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { colors } from '@guryou/colors';
import {
  Block,
  DefaultText,
  FacebookIcon,
  FlexColumn,
  FlexRow,
  GooglePlay,
  ImageLogo,
  ImageMedium,
  InstagramIcon,
  Itunes,
  LargeText,
  LinkButton,
  LinkedInIcon,
  Modal,
  PinterestIcon,
  TwitterIcon,
} from '@guryou/html-components';
import { useTheme } from '@material-ui/core/styles';
import Logo from 'assets/img/guryouLogos/gyLogo09.png';
import Contact from 'containers/ContactUs';
import DownloadApp from './DownloadApp';

const Footer = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const theme = useTheme();
  const [openDownload, setOpenDownload] = useState(false);
  const [openContact, setOpenContact] = useState(false);

  const content = [
    {
      title: t('FOOTER.discover'),
      actions: [
        {
          label: t('FOOTER.book'),
          action: () => history.push('/book'),
        },
        {
          label: t('FOOTER.read'),
          action: () => history.push('/read'),
        },
        {
          label: t('FOOTER.video'),
          action: () => history.push('/video'),
        },
        {
          label: t('FOOTER.downloadApp'),
          action: () => setOpenDownload(true),
        },
      ],
    },
    {
      title: t('FOOTER.business'),
      actions: [
        {
          label: t('FOOTER.registerBusiness'),
          action: () => window.location.replace('https://guryou.biz/'),
        },
      ],
    },
    {
      title: 'Guryou',
      actions: [
        {
          label: t('FOOTER.about'),
          action: () => history.push('/about'),
        },
        {
          label: t('FOOTER.contactUs'),
          action: () => setOpenContact(true),
        },
        {
          label: t('FOOTER.terms'),
          action: () => window.location.replace('https://www.iubenda.com/terms-and-conditions/8084171'),
        },
        {
          label: t('FOOTER.privacyPolicy'),
          action: () => window.location.replace('https://www.iubenda.com/privacy-policy/39480488'),
        },
        {
          label: t('FOOTER.cookiePolicy'),
          action: () => window.location.replace('https://www.iubenda.com/privacy-policy/39480488/cookie-policy'),
        },
      ],
    },
  ];

  return (
    <footer class={`p-4 sm:p-6 bg-[${colors.mandy}]`}>
      <div class="mx-auto max-w-screen-xl">
        <div class="md:flex md:justify-between">
          <div class="mb-6 md:mb-0">
            <a href="/" class="flex items-center">
              <img src={Logo} class="mr-3 h-8" alt="FlowBite Logo" />
            </a>
          </div>
          <div class="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
            {content.map(item => (
              <div key={item.title}>
                <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase text-white">{item.title}</h2>
                <ul class="text-gray-600">
                  {item.actions.map(key => (
                    <li class="mb-4" key={key.label} onClick={key.action}>
                      <a class="hover:underline text-white">{key.label}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <hr class="my-6 border-gray-200 sm:mx-auto lg:my-8" />
        <div class="sm:flex sm:items-center sm:justify-between">
          <span class="text-sm text-white sm:text-center">&copy; {t('FOOTER.copyright', { currentYear: new Date().getFullYear() })}© 2022 </span>
          <div class="flex mt-4 space-x-6 sm:justify-center sm:mt-0">
            <a href="https://www.facebook.com/guryou/" class="text-white hover:text-gray-900">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fill-rule="evenodd"
                  d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                  clip-rule="evenodd"
                />
              </svg>
            </a>
            <a href="https://www.instagram.com/guryou_official/" class="text-white hover:text-gray-900">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fill-rule="evenodd"
                  d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                  clip-rule="evenodd"
                />
              </svg>
            </a>
            <a href="https://twitter.com/guryou" class="text-white hover:text-gray-900">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/gy" class="text-white hover:text-gray-900">
              <svg
                class="w-5 h-5 text-white dark:text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  fill-rule="evenodd"
                  d="M12.51 8.796v1.697a3.738 3.738 0 0 1 3.288-1.684c3.455 0 4.202 2.16 4.202 4.97V19.5h-3.2v-5.072c0-1.21-.244-2.766-2.128-2.766-1.827 0-2.139 1.317-2.139 2.676V19.5h-3.19V8.796h3.168ZM7.2 6.106a1.61 1.61 0 0 1-.988 1.483 1.595 1.595 0 0 1-1.743-.348A1.607 1.607 0 0 1 5.6 4.5a1.601 1.601 0 0 1 1.6 1.606Z"
                  clip-rule="evenodd"
                />
                <path d="M7.2 8.809H4V19.5h3.2V8.809Z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      {/* <Block margin={0} background={theme.palette.primary.main} padding={4}>
        <FlexRow justifyContent="space-between" xs={12}>
          <ImageMedium src={Logo} maxHeight={80} />
          <FlexRow justifyContent="space-evenly" xs={8}>
            {content.map(item => (
              <FlexColumn alignItems="flex-start" key={item.title} paddingLeft={5} paddingRight={5}>
                <LargeText color={theme.palette.primary.contrastText} marginTop={5} marginBottom={5}>
                  {item.title}
                </LargeText>
                {item.actions.map(key => (
                  <DefaultText color={theme.palette.primary.contrastText} key={key.label} marginBottom={4} onClick={key.action}>
                    {key.label}
                  </DefaultText>
                ))}
              </FlexColumn>
            ))}
          </FlexRow>
          <Block width="100%" height="1px" backgroundColor={theme.palette.primary.contrastText} marginTop={10} marginBottom={4} />
          <FlexRow justifyContent="space-between" xs={12} margin={0}>
            <FlexRow xs={4}>
              <LinkButton to="https://www.facebook.com/guryou/" margin={4}>
                <FacebookIcon style={{ fill: 'white' }} fontSize="large" />
              </LinkButton>
              <LinkButton to="https://twitter.com/guryou" margin={4}>
                <TwitterIcon style={{ fill: 'white' }} fontSize="large" />
              </LinkButton>
              <LinkButton to="https://www.linkedin.com/company/gy" margin={4}>
                <LinkedInIcon style={{ fill: 'white' }} fontSize="large" />
              </LinkButton>
              <LinkButton to="https://www.pinterest.it/guryoupin/guryou/" margin={4}>
                <PinterestIcon style={{ fill: 'white' }} fontSize="large" />
              </LinkButton>
              <LinkButton to="https://www.instagram.com/guryou_official/" margin={4}>
                <InstagramIcon style={{ fill: 'white' }} fontSize="large" />
              </LinkButton>
            </FlexRow>

            <DefaultText xs={4} color={theme.palette.primary.contrastText} textAlign="center">
              &copy; {t('FOOTER.copyright', { currentYear: new Date().getFullYear() })}
            </DefaultText>

            <FlexRow xs={4} justifyContent="flex-end">
              <ImageLogo width={125} height={40} src={GooglePlay} margin={1} />
              <ImageLogo width={125} height={40} src={Itunes} margin={1} />
            </FlexRow>
          </FlexRow>
        </FlexRow>

        <Modal title={t('NAVBAR.contactUs')} id="contactUs" close={() => setOpenContact(false)} open={openContact}>
          <Contact />
        </Modal>
        <Modal id="downloadApp" title={t('NAVBAR.downloadApp')} close={() => setOpenDownload(false)} open={openDownload}>
          <DownloadApp />
        </Modal>
      </Block> */}
    </footer>
  );
};

export default Footer;
